// TODO: implement events page wrapper
export default function EventsPage() {
  return <div>Events Page</div>
}
